// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import VxeUIBase from 'vxe-pc-ui'
import 'vxe-pc-ui/es/style.css'
import VxeTable from 'vxe-table'
import XEUtils from 'xe-utils'
 // 导入主题变量，也可以重写主题变量
 import 'vxe-table/es/style.css'
 import { Icon } from '@iconify/vue' // 引入 Icon 组件


const app = createApp(App)
const pinia = createPinia()

// 1. 先使用 Pinia
app.use(pinia)
// 2. 再使用 Router
app.use(router)
// 切换为暗黑主题
// 3. 最后使用 VxeUIBase
 VxeUIBase.setConfig({
              size: "mini", // 全局尺寸
})
app.use(VxeUIBase)
app.use(VxeTable)
app.use(XEUtils)
app.component('Icon', Icon)
app.mount('#app')